module.exports = __webpack_public_path__ + "cart.svg?c6cd25dfa677cef65434197a603916cf";